export default __webpack_public_path__ + "img/bootstrap.bd712487.jpg";